import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ------------------------------------------------------------------
// এই অংশটা "Uncaught runtime errors: The user aborted a request"
// ওভারলে বন্ধ করার জন্য। এটা harmless error — যখন কোনো fetch() বা
// Firestore onSnapshot লিসেনার চলা অবস্থায় পেজ পরিবর্তন হয়ে যায়
// (ইউজার দ্রুত অন্য মেনুতে ক্লিক করে), তখন সেই রিকোয়েস্ট abort হয়ে
// একটা unhandled promise rejection তৈরি করে। এটা প্রোডাকশনে ইউজার
// দেখতে পায় না, কিন্তু dev মোডে বিরক্তিকর red overlay দেখায়।
// নিচের কোড শুধু "aborted" টাইপ error গুলোকে overlay-তে আসা থেকে
// আটকায়, আসল কোনো বাগ থাকলে সেটা এখনও কনসোলে/overlay-তে দেখাবে।
// ------------------------------------------------------------------
window.addEventListener('unhandledrejection', (event) => {
  const msg = event?.reason?.message || '';
  const name = event?.reason?.name || '';
  if (
    msg.includes('aborted') ||
    msg.includes('abort') ||
    name === 'AbortError'
  ) {
    event.preventDefault();
  }
});

window.addEventListener('error', (event) => {
  const msg = event?.error?.message || event?.message || '';
  if (msg.includes('aborted') || msg.includes('abort')) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();